import { z } from 'zod';

import { actionsSchema, translationSchema } from './job-role-details';
import { versionInformationSchema } from '../../../shared/source/data-contract/job-profile-versions';
import { jobArchitectureGenerationInfoSchema } from '../job-architecture/job-architecture';
import {
    creatorSchema,
    jobArchitectureProfileReviewerSchema,
    jobProfileLegacySchema,
} from '../job-profile/job-profile-schema';

export const jobLevelDetailsSchema = z
    .object({
        id: z.uuid(),
        actions: actionsSchema,
        architectureId: z.uuid(),
        creator: creatorSchema.optional(),
        externalId: z.string().optional(),
        jobProfile: jobProfileLegacySchema.optional(),
        parentId: z.uuid(),
        profileGenerationInfo: jobArchitectureGenerationInfoSchema.optional(),
        reviewer: jobArchitectureProfileReviewerSchema.optional(),
        title: z.string(),
        translations: translationSchema.array(),
        versionInfo: versionInformationSchema.optional(),
    })
    .transform((jobLevelDetails) => ({
        ...jobLevelDetails,
        type: 'job-level' as const,
    }));

export type JobLevelDetails = z.infer<typeof jobLevelDetailsSchema>;
